'use strict';

/**
 * Represents a validation error for an individual property
 * @param {object} fieldKey The objectKey of the field that contains an invalid value
 * @param {any} path The path to the invalid value on the field
 * @param {any} failureMessages An array of messages describing the failed validation
 * @returns {ValueValidationError} The created error object
 */

module.exports = function ValueValidationError(fieldKey, path, failureMessages) {
  this.field = fieldKey;
  this.path = path;
  this.messages = failureMessages;
};